module.exports = __webpack_public_path__ + "media/images/icon-bgm-on@3x-e55be9971d7e275c19a1e4337b76023e.png";